import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LeaderboardPage} from './leaderboard-page/leaderboard.page';
import {AuthOnlyGuard} from '../../guards/auth-only.guard';
import {LeaderboardWorldPage} from './leaderboard-world-page/leaderboard-world.page';
import {LeaderboardHubPage} from './leaderboard-hub-page/leaderboard-hub.page';
import {LeaderboardShoosmithsPage} from './leaderboard-shoosmiths-page/leaderboard-shoosmiths.page';
import {LeaderboardVeeamPage} from './leaderboard-veeam/leaderboard-veeam.page';
import {environment} from '../../../environments/environment';

const routes: Routes = [
  {
    path: '',
    component: environment.theme === 'veeam' ? LeaderboardVeeamPage : LeaderboardPage,
    data: {
      roomType: 'online',
      isRotate: true,
      isUserHighlighted: true
    }
  },
  {
    path: 'in-person/:room',
    component: LeaderboardVeeamPage,
    data: {
      roomType: 'in-person',
      isRotate: false,
      isUserHighlighted: false
    }
  },
  {
    path: 'virtual',
    component: LeaderboardVeeamPage,
    data: {
      roomType: 'virtual',
      isRotate: true,
      isUserHighlighted: false
    }
  },
  {
    path: 'world',
    component: LeaderboardWorldPage
  },
  {
    path: 'shoosmiths',
    component: LeaderboardShoosmithsPage
  },
  {
    path: 'shoosmiths/:section',
    component: LeaderboardShoosmithsPage
  },
  {
    path: 'hub/:name',
    component: LeaderboardHubPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class LeaderboardRoutingModule {
}
